import { useState } from "react"
import { apiJSONURL } from "../../../App"
import { decrypt } from "../../data/CryptoUtil"
import { useGlobalContext } from "../../data/GlobalContext"

export default function ChangePassword() {
  const { username, password } = useGlobalContext()
  const [currentPwd, setCurrentPwd] = useState("")
  const [newPwd, setNewPwd] = useState("")
  const [newPwd2, setNewPwd2] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [newPasswordVisible, setNewPasswordVisible] = useState(false)
  const [newConfirmPasswordVisible, setNewConfirmPasswordVisible] =
    useState(false)
  const isLoggedIn = Boolean(username)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isLoggedIn) return

    setMessage("Processing...")
    setLoading(true)

    if (!currentPwd) {
      setMessage("Please fill the current password")
      setLoading(false)
      return
    }
    if (!newPwd) {
      setMessage("Please fill the new password")
      setLoading(false)
      return
    }
    if (!newPwd2) {
      setMessage("Please fill the confirm new password")
      setLoading(false)
      return
    }

    if (newPwd.length < 6) {
      setMessage("Your new password is too short (6-8 characters)")
      setLoading(false)
      return
    }
    if (newPwd !== newPwd2) {
      setMessage("New Password and Confirm new password do not match!")
      setLoading(false)
      return
    }

    const formData = new URLSearchParams()
    formData.append("cmd", "changePassword")
    formData.append("u", username)
    formData.append("pwd", newPwd)
    formData.append("oldpwd", currentPwd)

    try {
      const response = await fetch(apiJSONURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })

      const data = await response.json()
      if (data.s) {
        setMessage(data.s)
        setCurrentPwd("")
        setNewPwd("")
        setNewPwd2("")
      } else {
        setMessage(data.emsg || "An error occurred.")
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      setMessage("An error occurred, please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="change-password-container">
        <div className="change-password-container--notice">
          Notice: Password needs to be between 6 – 8 characters.
        </div>
        <form onSubmit={handleSubmit}>
          <div className="password-field">
            <input
              type={passwordVisible ? "text" : "password"}
              placeholder="Current Password"
              value={currentPwd}
              onChange={(e) => setCurrentPwd(e.target.value)}
              autoComplete="off"
              maxLength={8}
            />
            <span onClick={() => setPasswordVisible(!passwordVisible)}>
              {passwordVisible ? (
                <img
                  src="/images/icon/hide-password.webp"
                  alt="Hide Password"
                  className="password-icon-status"
                />
              ) : (
                <img
                  src="/images/icon/reveal-password.webp"
                  alt="Show Password"
                  className="password-icon-status"
                />
              )}
            </span>
          </div>
          <div className="password-field">
            <input
              type={newPasswordVisible ? "text" : "password"}
              name="pwd"
              placeholder="New Password"
              value={newPwd}
              onChange={(e) => setNewPwd(e.target.value)}
              autoComplete="off"
              maxLength={8}
            />{" "}
            <span onClick={() => setNewPasswordVisible(!newPasswordVisible)}>
              {newPasswordVisible ? (
                <img
                  src="/images/icon/hide-password.webp"
                  alt="Hide Password"
                  className="password-icon-status"
                />
              ) : (
                <img
                  src="/images/icon/reveal-password.webp"
                  alt="Show Password"
                  className="password-icon-status"
                />
              )}
            </span>
          </div>
          <div className="password-field">
            <input
              type={newConfirmPasswordVisible ? "text" : "password"}
              name="newPwd2"
              placeholder="Confirm New Password"
              value={newPwd2}
              onChange={(e) => setNewPwd2(e.target.value)}
              autoComplete="off"
              maxLength={8}
            />
            <span
              onClick={() =>
                setNewConfirmPasswordVisible(!newConfirmPasswordVisible)
              }
            >
              {newConfirmPasswordVisible ? (
                <img
                  src="/images/icon/hide-password.webp"
                  alt="Hide Password"
                  className="password-icon-status"
                />
              ) : (
                <img
                  src="/images/icon/reveal-password.webp"
                  alt="Show Password"
                  className="password-icon-status"
                />
              )}
            </span>
          </div>

          {message && <div className="change-password-msg">{message}</div>}
          <div className="change-pass-container">
            <button
              className={`change-password-btn ${
                currentPwd.trim() === "" ||
                newPwd.trim() === "" ||
                newPwd2.trim() === ""
                  ? "disabled"
                  : ""
              }`}
              type="submit"
              disabled={
                currentPwd.trim() === "" ||
                newPwd.trim() === "" ||
                newPwd2.trim() === "" ||
                loading
              }
            >
              {loading ? "Processing..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}
